import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ScheduleAppointment from './scheduleAppointment';
import {
	Button,
	Grid,
	Modal,
	Alert,
	Typography,
	FormControl,
	Select,
	MenuItem,
	Snackbar,
	TextField,
} from '@mui/material';
import { Cancel } from '@mui/icons-material';
import { useStateValue } from '../../../services/state/State';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import {
	addAppointment,
	getAppointment,
	getLocation,
	getPatientList,
	getPracticeStaff,
	updateAppointment,
} from '../../../services/api/apiManager';
// import { useState } from 'react';
import dayjs from 'dayjs';
import Schedular from './Schedular';
// import { getAppointment } from '../../../services/api/apiManager';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	background: 'white',
	fontFamily: 'Poppins',
	borderRadius: '10px',
	width: '70%',
};

export default function ScheduleAppointmentMain() {
	const [renderAgain, setRenderAgain] = useState(0);
	const practiceId = localStorage.getItem('practice_id');
	const [value, setValue] = React.useState('1');
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	// // for updating appointment
	// const updateAppointmentInfo = async (id, data) => {
	// 	const resp = await updateAppointment(id, data);
	// 	if (resp?.status === 200) {
	// 		setPostSucessfully(true);
	// 		updateModalhandleClose();
	// 		// handleCloseDeleteModal();
	// 		setRenderAgain((prev) => prev + 1);
	// 		setupdateAppointmentSnackbar(true);
	// 		if (resp?.data.Deleted === true) {
	// 			setDeleteAppointment(true);
	// 		}

	// 		setOpenSnackbar(true);
	// 	} else if (resp?.status === undefined) {
	// 		setPostSucessfully(false);
	// 		setOpenSnackbar(true);
	// 	}
	// };

	const [{ patients, locations, practice }, dispatch] = useStateValue();

	const [invalidInfo, setInvalidInfo] = useState(false);
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [postSucessfully, setPostSucessfully] = useState(true);
	const [updateAppointmentSnackbar, setupdateAppointmentSnackbar] =
		useState(false);
	const [deleteAppointment, setDeleteAppointment] = useState(false);
	const defaultTheme = createTheme();
	const [selectedDate, setselectedDate] = useState(dayjs(new Date()));
	const [patientList, setPatientList] = useState([]);
	const [filterLocation, setFilterLocation] = React.useState('');
	const [week, setWeek] = React.useState('');
	const [open, setOpen] = React.useState(false);
	const handleOpen = () => setOpen(true);
	const handleCloseModal = () => {
		setappoitment({
			patient_id: '',
			provider_id: '',
			AppointmentDate: dayjs(selectedDate),
			location_id: '',
			Status: 'P',
			Reason: '',
		});
		setOpen(false);
	};

	const [staffList, setStaffList] = useState([]);
	const [location, setLocation] = useState([]);
	const [provider, setProvider] = React.useState('');
	// const [selectedFilterDate, setselectedFilterDate] = useState(null);
	const practice_id = localStorage.getItem('practice_id');

	const [appointment, setappoitment] = useState({
		// practice_id: practice_id,
		patient_id: '',
		provider_id: '',
		location_id: '',
		AppointmentDate: dayjs(selectedDate),
		Status: 'P',
		Reason: '',
	});

	const handleCloseSnackbar = () => setOpenSnackbar(false);

	const getLocationsData = async () => {
		const resp = await getLocation();
		if (resp?.status === 200) {
			setLocation(resp?.data);
		}
	};

	const fetchPatientList = async (id) => {
		const resp = await getPatientList(id);
		if (resp.status === 200) {
			setPatientList(resp?.data);
		} else {
			setPatientList([]);
		}
	};

	const fetchPracticeStaff = async () => {
		debugger;
		const res = await getPracticeStaff();
		if (res && res.data && res.data.length > 0) {
			setStaffList(res.data);
		} else {
			setStaffList([]);
		}
	};
	// for adding new appointments
	const addNewAppointment = async (data) => {
		const resp = await addAppointment(data);
		if (resp.status === 201) {
			setPostSucessfully(true);
			setOpenSnackbar(true);
			setOpen(false);
			setRenderAgain((prev) => prev + 1);
			setappoitment({
				patient_id: '',
				provider_id: '',
				AppointmentDate: dayjs(selectedDate),
				Status: 'P',
				location_id: '',
				Reason: '',
			});
			// fetchAppointments();
			setselectedDate(dayjs(new Date()));
		} else if (resp?.status === undefined) {
			setPostSucessfully(false);
			setOpenSnackbar(true);
		}
	};

	const mappingPatientsList =
		patients &&
		patients?.map((row) => ({
			patientId: row.patient_id,
			patientName: row.Name,
		}));

	const mappingProviderList =
		staffList &&
		staffList?.map((row) => ({
			name: row.Fname + ' ' + row.Lname,
			providerId: row.id,
		}));

	useEffect(() => {
		getLocationsData();
		fetchPatientList(practiceId);
		fetchPracticeStaff();
	}, []);

	return (
		<Box sx={{ width: '100%', typography: 'body1' }}>
			<TabContext value={value}>
				<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
					<TabList onChange={handleChange} aria-label="lab API tabs example">
						<Tab
							style={{
								fontSize: '18px',
								fontWeight: '500',
								fontFamily: 'Poppins',
								paddingBottom: '0px',
								paddingTop: '0px',
								textTransform: 'capitalize',
							}}
							label="List View"
							value="1"
						/>
						<Tab
							style={{
								fontSize: '18px',
								fontWeight: '500',
								fontFamily: 'Poppins',
								paddingBottom: '0px',
								paddingTop: '0px',
								textTransform: 'capitalize',
							}}
							label="Calender View"
							value="2"
						/>
					</TabList>
					{/* <Button
						onClick={handleOpen}
						startIcon={<PersonAddIcon />}
						sx={{
							position: 'absolute',
							top: '9%',
							color: 'white',
							right: '2%',
							background: '#FD7702',
							fontWeight: '500',
							fontFamily: 'Poppins',
							'&:hover': {
								border: '#FD7702',
								color: '#FD7702',
								background: 'white',
							},
							'@media (max-width: 600px)': {
								// Styles for xs and sm screens
								position: 'relative',
								margin: '10px',
							},
							'@media (max-height: 700px)': {
								// Styles for xs and sm screens
								top: '11%',
								right: '3%',
							},
							'@media (max-width: 900px)': {
								// Styles for xs and sm screens
								top: '9%',
								right: '2%',
							},
						}}
					>
						Add
					</Button> */}
				</Box>
				<TabPanel value="1" sx={{ padding: '0px' }}>
					<ScheduleAppointment reRenderFromParent={renderAgain} />
				</TabPanel>
				<TabPanel value="2" sx={{ padding: '0px' }}>
					<Schedular
						reRenderFromParent={renderAgain}
						updatingSnackbar={setupdateAppointmentSnackbar}
						deletingAppointment={setDeleteAppointment}
					/>
				</TabPanel>
			</TabContext>

			{/* Modal */}
			<Modal
				open={open}
				onClose={handleCloseModal}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<Box
						width={'100%'}
						display={'flex'}
						alignItems={'center'}
						justifyContent={'flex-end'}
						bgcolor={'#0e4374'}
						height={'30px'}
						p={0}
						borderRadius={'10px 10px 0 0 '}
					>
						<Cancel
							sx={{ cursor: 'pointer', color: 'whitesmoke' }}
							onClick={() => {
								handleCloseModal();
								setInvalidInfo(false);
								setappoitment({
									patient_id: '',
									provider_id: '',
									AppointmentDate: dayjs(selectedDate),
									location_id: '',
									Status: 'P',
									Reason: '',
								});
							}}
						/>
					</Box>
					{invalidInfo && (
						<Box
							display={
								appointment?.patient_id === ''
									? ''
									: appointment?.provider_id === ''
										? ''
										: appointment?.Status === ''
											? ''
											: appointment?.Reason === ''
												? ''
												: appointment?.AppointmentDate == 'Invalid Date'
													? ''
													: appointment?.location_id === ''
														? ''
														: 'none'
							}
						>
							<Alert variant="filled" severity="error">
								Please Fill all Information!
							</Alert>
						</Box>
					)}
					<Typography
						id="modal-modal-title"
						variant="h6"
						component="h2"
						sx={{
							textAlign: 'center',
							fontWeight: '500',
							fontFamily: 'Poppins',
						}}
					>
						Add Appointment
					</Typography>
					<Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
						<Grid container item xs={12} sm={12} md={6} lg={6} xl={6}>
							<Grid item xs={12} sm={12} md={11} lg={11} xl={11}>
								<Grid
									item
									xs={12}
									lg={12}
									md={12}
									sm={12}
									xl={12}
									sx={{
										padding: ' 3px 13px',
									}}
								>
									<Typography
										variant="body1"
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
										}}
									>
										Select Patient
									</Typography>
									<FormControl
										fullWidth
										size="small"
										sx={{
											border: '1px solid #00000026',
											borderRadius: '4px',
										}}
									>
										<Select
											MenuProps={{
												PaperProps: {
													style: {
														width: '8.3%',
														height: '18%',
														overflowY: 'scroll',
														overflowX: 'scroll',
													},
												},
											}}
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											placeholder="Add Patient"
											value={appointment?.patient_id}
											onChange={(e) => {
												setappoitment((prev) => ({
													...prev,
													patient_id: e.target.value,
													provider_id: (patientList?.filter(
														(items) => items?.patient_id === e.target.value
													))[0]?.providerid,
													location_id: (patientList?.filter(
														(items) => items?.patient_id === e.target.value
													))[0]?.locationid,
												}));
											}}
										>
											<MenuItem value={''}>Patients</MenuItem>
											{patientList?.map((items, index) => (
												<MenuItem
													key={index}
													value={items?.patient_id}
													// style={{ width: '100%' }}
												>
													{items?.Name}
												</MenuItem>
											))}
										</Select>
									</FormControl>
								</Grid>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								md={11}
								lg={11}
								xl={11}
								sx={{
									padding: '8px 13px',
								}}
							>
								<Typography
									variant="body2"
									sx={{
										color: '#333',
										fontSize: '14px',
										fontFamily: 'Poppins',
										fontWeight: '500',
									}}
								>
									Reason
								</Typography>
								<TextField
									multiline
									fullWidth
									name="Reason"
									rows={3}
									sx={{
										borderRadius: '6px',
										border: '1px solid #00000026',
									}}
									value={appointment?.Reason}
									onChange={(e) =>
										setappoitment((prev) => ({
											...prev,
											Reason: e.target.value,
										}))
									}
								/>
							</Grid>
						</Grid>

						<Grid item container xs={12} sm={12} md={6} lg={6} xl={6}>
							<Grid
								item
								xs={12}
								sm={12}
								md={5.5}
								lg={5.5}
								xl={5.5}
								// sx={{ margin: '5px' }}
							>
								<Typography
									variant="body2"
									sx={{
										color: '#333',
										fontSize: '14px',
										fontFamily: 'Poppins',
										fontWeight: '500',
									}}
								>
									Appointment Date Time
								</Typography>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DemoContainer components={['DateTimePicker']}>
										<DemoItem>
											<DateTimePicker
												orientation="portrait"
												disablePast
												size="small"
												slotProps={{ textField: { size: 'small' } }}
												sx={{
													// boxShadow: '1px 1px 10px #79ACF178 inset',
													width: '100%',
												}}
												value={selectedDate}
												onChange={(nValue) => {
													setselectedDate(nValue);
													setappoitment((prev) => ({
														...prev,
														AppointmentDate: dayjs(nValue),
													}));
												}}
											/>
										</DemoItem>
									</DemoContainer>
								</LocalizationProvider>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								md={5.5}
								lg={5.5}
								xl={5.5}
								sx={{ marginLeft: '5px' }}
							>
								<Typography
									variant="body2"
									sx={{
										color: '#333',
										fontSize: '14px',
										fontFamily: 'Poppins',
										fontWeight: '500',
										pb: '8px',
									}}
								>
									Location
								</Typography>
								<FormControl fullWidth size="small">
									<Select
										MenuProps={{
											PaperProps: {
												style: {
													width: '8.3%',
													height: '15%',
													overflowY: 'scroll',
													overflowX: 'scroll',
												},
											},
										}}
										placeholder="Select Location"
										labelId="modallocation"
										id="modallocation"
										value={appointment?.location_id}
										name="modallocation"
										// sx={{ height: '45px', mt: 1 }}
										onChange={(e) => {
											setappoitment((prev) => ({
												...prev,
												location_id: e.target.value,
											}));
										}}
									>
										{location?.map((items, index) => {
											return (
												<MenuItem key={index} value={items?.id}>
													{items?.Name}
												</MenuItem>
											);
										})}
									</Select>
								</FormControl>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								md={5.5}
								lg={5.5}
								xl={5.5}
								sx={{ margin: '5px' }}
							>
								<Typography
									variant="body2"
									sx={{
										color: '#333',
										fontSize: '14px',
										fontFamily: 'Poppins',
										fontWeight: '500',
									}}
								>
									Provider Name
								</Typography>
								<FormControl
									fullWidth
									name="providerId"
									sx={{
										borderRadius: '6px',
										border: '1px solid #00000026',
										// boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
										'& .MuiOutlinedInput-input': {
											padding: '9px 0px 9px 6px',
										},
									}}
								>
									<Select
										MenuProps={{
											PaperProps: {
												style: {
													width: '8.3%',
													height: '18%',
													overflowY: 'scroll',
													overflowX: 'scroll',
												},
											},
										}}
										labelId="demo-simple-select-label"
										id="demo-simple-select"
										placeholder="Select Provider Name"
										value={appointment?.provider_id}
										onChange={(e) =>
											setappoitment((prev) => ({
												...prev,
												provider_id: e.target.value,
											}))
										}
									>
										<MenuItem value={0} style={{ width: '100%' }} disabled>
											Provider
										</MenuItem>
										{mappingProviderList &&
											mappingProviderList.length > 0 &&
											mappingProviderList.map((item, index) => (
												<MenuItem
													key={index}
													value={item?.providerId}
													style={{ width: '100%' }}
												>
													{item?.name}
												</MenuItem>
											))}
									</Select>
								</FormControl>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								md={5.5}
								lg={5.5}
								xl={5.5}
								sx={{ margin: '5px' }}
							>
								<Typography
									variant="body2"
									sx={{
										color: '#333',
										fontSize: '14px',
										fontFamily: 'Poppins',
										fontWeight: '500',
									}}
								>
									Appointment Status
								</Typography>

								<FormControl fullWidth size="small">
									<Select
										labelId="Status"
										id="Status"
										value={appointment?.Status}
										name="Status"
										onChange={(e) => {
											setappoitment((prev) => ({
												...prev,
												Status: e.target.value,
											}));
										}}
										sx={{
											width: '100%',
											borderRadius: '6px',
											border: '1px solid #00000026',
											// boxShadow: ' 0px 1px 10px 0px #79ACF178 inset',
											'& .MuiOutlinedInput-input': {
												padding: '9px 0px 9px 6px',
											},
										}}
									>
										<MenuItem value={'C'}>Completed</MenuItem>
										<MenuItem value={'D'}>Dismissed</MenuItem>
										<MenuItem value={'O'}>Other</MenuItem>
										<MenuItem value={'P'}>Pending</MenuItem>
									</Select>
								</FormControl>
							</Grid>
						</Grid>
					</Grid>
					<Grid
						item
						sx={{
							display: 'flex',
							justifyContent: 'flex-end',
							gap: '5px',
							padding: '13px 8px 0px 8px',
						}}
						xs={12}
					>
						<Button
							onClick={() => {
								handleCloseModal();
								setInvalidInfo(false);
								setappoitment({
									patient_id: '',
									provider_id: '',
									AppointmentDate: dayjs(new Date()),
									location_id: '',
									Status: 'P',
									Reason: '',
								});
								setselectedDate(dayjs(new Date()));
							}}
							sx={{
								mb: 1,
								background: '#ED2828',
								border: '2px solid #ED2828',
								color: 'white',
								fontFamily: 'Poppins',
								fontSize: '15px',
								fontWeight: '500',
								padding: '7px 15px',
								'&:hover': {
									border: '2px solid #ED2828',
									color: '#ED2828',
								},
							}}
						>
							Cancel
						</Button>

						<Button
							// disabled={
							// 	appointment?.patient_id === ''
							// 		? true
							// 		: appointment?.provider_id === ''
							// 			? true
							// 			: appointment?.Status === ''
							// 				? true
							// 				: appointment?.Reason === ''
							// 					? true
							// 					: appointment?.AppointmentDate == 'Invalid Date'
							// 						? true
							// 						: appointment?.location_id === ''
							// 							? true
							// 							: false
							// }
							sx={{
								mb: 1,
								background: '#FD7702',
								border: '2px solid #e87511',
								color: 'white',
								fontFamily: 'Poppins',
								fontSize: '15px',
								fontWeight: '500',
								padding: '7px 15px',
								'&:hover': {
									border: '2px solid #e87511',
									color: '#e87511',
								},
							}}
							onClick={() => {
								if (
									appointment?.patient_id === '' ||
									appointment?.provider_id === '' ||
									appointment?.Status === '' ||
									appointment?.Reason === '' ||
									appointment?.AppointmentDate == 'Invalid Date' ||
									appointment?.location_id === ''
								) {
									setInvalidInfo(true);
								} else {
									addNewAppointment(appointment);
								}
							}}
						>
							Add Appointment
						</Button>
					</Grid>
				</Box>
			</Modal>

			{/* SnackBar */}
			<Snackbar
				open={openSnackbar}
				autoHideDuration={1800}
				onClose={handleCloseSnackbar}
				anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
			>
				<Alert
					onClose={handleCloseSnackbar}
					severity={!postSucessfully ? 'error' : 'success'}
					variant="filled"
					sx={{
						width: '100%',
						height: '3.5rem',
						textAlign: 'center',
						fontSize: '1.1rem',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
					action={
						<React.Fragment>
							<span
								onClick={handleCloseSnackbar}
								style={{
									cursor: 'pointer',
									m: 'auto 0',
									fontSize: '13px',
									color: 'rgb(231, 231, 231)',
								}}
							>
								Close
							</span>
						</React.Fragment>
					}
				>
					{!postSucessfully ? 'Error!' : 'Appointment Added Successfully!'}
				</Alert>
			</Snackbar>

			{/* Child Component SnackBar that showing on update of Appointment */}
			<Snackbar
				open={updateAppointmentSnackbar}
				autoHideDuration={1800}
				onClose={() => {
					setupdateAppointmentSnackbar(false);
					setDeleteAppointment(false);
				}}
				anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
			>
				<Alert
					onClose={() => {
						setupdateAppointmentSnackbar(false);
						setDeleteAppointment(false);
					}}
					severity={'success'}
					variant="filled"
					sx={{
						width: '100%',
						height: '3.5rem',
						textAlign: 'center',
						fontSize: '1.1rem',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
					action={
						<React.Fragment>
							<span
								onClick={handleCloseSnackbar}
								style={{
									cursor: 'pointer',
									m: 'auto 0',
									fontSize: '13px',
									color: 'rgb(231, 231, 231)',
								}}
							>
								Close
							</span>
						</React.Fragment>
					}
				>
					{deleteAppointment
						? `Appointment Deleted Successfully!`
						: `Appointment Updated Successfully!`}
				</Alert>
			</Snackbar>
		</Box>
	);
}
